import VulnerabilityIcon from './VulnerabilityIcon';

export default VulnerabilityIcon;
export { VulnerabilityIcon };
